<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="sidebarx" spacer v-model="updateStoreConfig.isOpen" id="edit-store-sidebar">
        <div class="flex items-center justify-between px-6">
            <h4 class="text-2xl font-bold">Edit Store</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>
        <!-- <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings"> -->
            <div class="scroll-area--data-list-add-new">
            <div class="sidebar-content p-6 h-full overflow-auto">
                <div class="info-form mb-base">
                    <h4 class="text-lg font-bold m-0">Name</h4>
                    <vs-input class="w-full" />

                    <h4 class="text-lg font-bold m-0 mt-6">Short Name</h4>
                    <vs-input class="w-full" />

                    <h4 class="text-lg font-bold m-0 mt-6">Phone</h4>
                    <vs-input class="w-full" />

                    <h4 class="text-lg font-bold m-0 mt-6">Email</h4>
                    <vs-input class="w-full" />

                    <h4 class="text-lg font-bold m-0 mt-6">Address</h4>
                    <vs-input class="w-full" />

                    <div class="flex">
                        <div class="w-1/2 pr-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Service Tax(%)</h4>
                            <vs-input class="w-full" />
                        </div>

                        <div class="w-1/2 pl-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Product Tax(%)</h4>
                            <vs-input class="w-full" />
                        </div>
                    </div>

                    <h4 class="text-lg font-bold m-0 mb-2 mt-6">Timezone</h4>
                    <v-select :options="timezoneList" label="name" :clearable="false" />

                    <h4 class="text-lg font-bold m-0 mb-2 mt-6">State</h4>
                    <v-select :options="stateList" label="name" :clearable="false" />

                    <div class="flex">
                        <div class="w-1/2 pr-3">
                            <h4 class="text-lg font-bold m-0 mt-6">City</h4>
                            <vs-input class="w-full" />
                        </div>

                        <div class="w-1/2 pl-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Zip Code</h4>
                            <vs-input class="w-full" />
                        </div>
                    </div>

                    <h4 class="text-lg font-bold m-0 mb-2 mt-6">Mode</h4>
                    <v-select :options="modeList" label="name" :clearable="false" />

                    <div class="flex">
                        <div class="w-1/2 pr-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Percent for Owner(%)</h4>
                            <vs-input class="w-full" />
                        </div>

                        <div class="w-1/2 pl-3">
                            <h4 class="text-lg font-bold m-0 mt-6">Percent for Staff(%)</h4>
                            <vs-input class="w-full" />
                        </div>
                    </div>

                    <div class="flex align-center mt-6">
                        <div class="w-1/2 pr-3">
                            <vs-checkbox v-model="credit_card" class="mr-2 text-lg font-bold color-black">Credit Card</vs-checkbox>
                        </div>
                        <transition name="list">
                            <div class="flex align-center w-1/2 pl-3" v-if="credit_card">$1 is equal to <vs-input class="equal-point-input mx-2" /> pts</div>
                        </transition>
                    </div>

                    <div class="flex align-center">
                        <div class="w-1/2 pr-3">
                            <vs-checkbox v-model="cash" class="mr-2 text-lg font-bold color-black">Cash</vs-checkbox>
                        </div>
                        <transition name="list">
                            <div class="flex align-center w-1/2 pl-3" v-if="cash">$1 is equal to <vs-input class="equal-point-input mx-2" /> pts</div>
                        </transition>
                    </div>

                    <div class="flex align-center">
                        <div class="w-1/2 pr-3">
                            <vs-checkbox v-model="gift_card" class="mr-2 text-lg font-bold color-black">Gift Card</vs-checkbox>
                        </div>
                        <transition name="list">
                            <div class="flex align-center w-1/2 pl-3" v-if="gift_card">$1 is equal to  <vs-input class="equal-point-input mx-2" /> pts</div>
                        </transition>
                    </div>

                    <div class="flex align-center">
                        <div class="w-1/2 pr-3">
                            <vs-checkbox v-model="check" class="mr-2 text-lg font-bold color-black">Check</vs-checkbox>
                        </div>
                        <transition name="list">
                            <div class="flex align-center w-1/2 pl-3" v-if="check">$1 is equal to <vs-input class="equal-point-input mx-2" /> pts</div>
                        </transition>
                    </div>
                </div>
            </div>
            </div>
        <!-- </VuePerfectScrollbar> -->
        <div class="flex flex-wrap items-center p-6 justify-center" slot="footer">
            <vs-button class="mr-6" @click.stop="updateStore" style="min-width: 140px;">Save</vs-button>
            <vs-button type="border" color="danger" @click.stop="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import vSelect from 'vue-select';
export default {
    name: 'edit-store-sidebar',
    components: {
        'v-select': vSelect,
        // VuePerfectScrollbar
    },
    props: {
        updateStoreConfig: {
            type: Object
        },
        storeInfo: {
            type: Object
        }
    },
    data() {
        return {
            timezoneList: [
                {name: 'America/Los_Angeles | -07:00 PDT - DST'},
                {name: 'America/Tijuana | -07:00 PDT - DST'},
            ],
            stateList: [
                {name: 'LA - Louisiana'},
                {name: 'ME - Maine'},
            ],
            modeList: [
                {name: 'FULL'},
                {name: 'LITE'}
            ],
            credit_card: true,
            cash: true,
            gift_card: true,
            check: true,
            settings: { // perfectscrollbar settings
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
        }
    },
    methods: {
        updateStore() {

        },
        closeSidebar() {
            this.updateStoreConfig.isOpen = false;
        },
    }
}
</script>